<main>
    <div class="container">

        <div class="row mt-5 pt-5 mb-5">
            <div class="col-sm-8 pb-0">
                <div class="leftbanner-content">
                    <h1>Jeg {{pageType == 'lost' ? 'har funnet' : 'savner'}} et kjæledyr</h1>
                    <p *ngIf="pageType == 'lost'"> Her får du enkelt oversikt over alle dyr som er meldt savnet.
                        Finner du ikke dyret i listen eller på kartet? Logg inn og meld dyret som funnet.</p>
                    <p *ngIf="pageType == 'found'"> Her får du enkelt oversikt over alle dyr som er meldt funnet.
                        Finner du ikke dyret i listen eller på kartet? Logg inn og meld dyret som savnet.</p>
                    <div class="callto-action">
                        <a (click)="scroll(1)" class="btn btn-white width-100 mb-2 f-16" type="btn">
                            Se {{pageType == 'lost' ? 'savnede' : 'funnet'}} hunder nær deg
                            <i class="fas fa-arrow-right"></i>
                        </a>
                        <a (click)="scroll(2)" class="btn btn-white width-100 custom-ml-3 mb-2 mbl-xm f-16" type="btn">
                            Se {{pageType == 'lost' ? 'savnede' : 'funnet'}} katter nær deg
                            <i class="fas fa-arrow-right"></i></a>
                    </div>
                    <div class="callto-action">
                        <a (click)="routeToPage()" class="btn btn-white width-100 mb-2 f-16" type="btn">
                            Meld dyret som {{pageType == 'lost' ? 'funnet' : 'savnet'}}
                            <i class="fas fa-arrow-right"></i>
                        </a>
                        <a *ngIf="showpetlist" (click)="gotoPetList()"
                            class="btn btn-white width-100 custom-ml-3 mb-2 mbl-xm f-16" type="btn">
                            {{'Minside Pet List' | translate}}<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 pb-0 ">
                <div class="banner-slider">
                    <img src="assets/img/banne-1.jpg" class="img-fluid" alt="" />
                    <div class="grey-overlay-n"></div>
                </div>
            </div>
        </div>

        <app-search id="target-el"> </app-search>

    </div>
</main>